var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('draggable',{attrs:{"draggable":_vm.draggable},on:{"end":_vm.onEnd}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }